import React from "react";

export default class RelatedProjects extends React.Component {
  render() {
    return (
      <div className="related-projects">
        <ul>
          <a
            href="https://gerillass.com"
            title="An open-source Sass library!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>
              <figure>
                <img
                  src={require("assets/images/related-gerillass.png")}
                  alt="Gerillass"
                />
              </figure>
              <div className="right">
                <div className="title">Gerillass</div>
                <p className="description">
                  Gerillass is an open-source Sass library with a set of mixins
                  and functions.
                </p>
              </div>
            </li>
          </a>

          <a
            href="https://www.flexible-grid.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Flexible Grid"
          >
            <li>
              <figure>
                <img
                  src={require("assets/images/related-flexible-grid.png")}
                  alt="Flexible Grid"
                />
              </figure>
              <div className="right">
                <div className="title">Flexible Grid</div>
                <p className="description">
                  Flexible Grid is an open-source framework for developers to
                  build web sites easily.
                </p>
              </div>
            </li>
          </a>

          <a
            href="https://www.fontisto.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Fontisto: Free Icon Library"
          >
            <li>
              <figure>
                <img
                  src={require("assets/images/related-fontisto.png")}
                  alt="Fontisto"
                />
              </figure>
              <div className="right">
                <div className="title">Fontisto</div>
                <p className="description">
                  Fontisto is an open-source font icon library for designers and
                  developers.
                </p>
              </div>
            </li>
          </a>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RelatedProjects/RelatedProjects.js